var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1033 4.81663C11.4701 4.07346 12.5299 4.07346 12.8967 4.81663L14.5486 8.16309C14.6941 8.45794 14.9753 8.6624 15.3006 8.70995L18.9962 9.25012C19.8161 9.36996 20.1429 10.3778 19.5493 10.956L16.8768 13.559C16.6409 13.7887 16.5333 14.1199 16.5889 14.4444L17.2194 18.1206C17.3595 18.9376 16.502 19.5606 15.7684 19.1747L12.4655 17.4378C12.1741 17.2845 11.8259 17.2845 11.5345 17.4378L8.23163 19.1747C7.498 19.5606 6.64045 18.9376 6.78057 18.1206L7.41109 14.4444C7.46675 14.1199 7.35908 13.7887 7.12321 13.559L4.45068 10.956C3.85709 10.3778 4.18387 9.36996 5.00378 9.25012L8.69937 8.70995C9.02472 8.6624 9.30591 8.45794 9.45145 8.16309L11.1033 4.81663Z",
    fill: "#335CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blue_star.10606277d89b973080119c38e1adaaaf.svg";
export { ForwardRef as ReactComponent };